import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const QuoteCardHeader = ({ title, subTitle, logoUrl, children, }) => {
    const styles = useStyles(styleSheet);
    return (<View style={styles.row}>
      <View style={styles.logoContainer}>
        <Image source={{ uri: logoUrl }} style={staticStyles.logo} resizeMode="contain"/>
      </View>
      <Spacer.W16 />
      <View style={styles.flex}>
        <Text Text-16>{title}</Text>
        <Text TextThin-14 Secondary>
          {subTitle}
        </Text>
      </View>
      {children}
    </View>);
};
const staticStyles = StyleSheet.create({
    logo: {
        width: rem(44),
        height: rem(44),
    },
});
const styleSheet = createStyleSheets((colors) => ({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    flex: { flex: 1 },
    logoContainer: {
        width: rem(44),
        height: rem(44),
        borderRadius: rem(8),
        backgroundColor: colors.elements.white,
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
}));
export default QuoteCardHeader;
